import type { QueryClient } from "@tanstack/solid-query";
import { queryKeys } from "@jornada/shared";
import { showToast } from "@/components/ui/toast";

/** Test id of the error toast shown when a device could not be signed out. */
export const REVOKE_ERROR_TEST_ID = "revoke-session-error";

/**
 * What the device list does when a revoke finishes. Kept out of BootManager so
 * the wiring can be tested without mounting the whole boot machine.
 */
export function createRevokeFeedback(options: {
  queryClient: QueryClient;
  errorMessage: () => string;
}) {
  const refreshDevices = () => {
    void options.queryClient.invalidateQueries({ queryKey: queryKeys.auth.activeSessions() });
  };

  return {
    onRevokeSuccess: refreshDevices,
    onRevokeError: () => {
      showToast(options.errorMessage(), "error", { testId: REVOKE_ERROR_TEST_ID });
      // The list may have become out of sync with the server: it is refetched
      // so that what is seen matches reality, not the attempt.
      refreshDevices();
    },
  };
}
